import { ComponentProps } from 'react';
import classNames from 'classnames';
import { Button } from 'app/agriculture/components/Button/Button';
import './MainNav.scss';
import { Collapse } from '@mui/material';

type NavItem = ComponentProps<typeof Button> & {
    subMenuItems?: ComponentProps<typeof Button>[];
};

interface MainNavProps {
    items: NavItem[];
    activeTab: string;
}

export function MainNav({ items, activeTab }: MainNavProps) {
    if (items.length === 0) {
        return null;
    }

    return (
        <div
            className="MainNav"
            style={{ '--nav-index': items.findIndex(({ text }) => text === activeTab) }}
        >
            {items.map(({ subMenuItems = [], className, text, ...item }) => (
                <div
                    key={text}
                    className={classNames('MainNav__item', className, {
                        'MainNav__item--active': activeTab === text,
                    })}
                >
                    <Button
                        {...item}
                        text={text}
                        className={classNames('MainNav__primary_button', {
                            'MainNav__primary_button--active': activeTab === text,
                        })}
                        variant="textonly"
                    />
                    {subMenuItems.length === 0 ? null : (
                        <Collapse in={activeTab === text} className="MainNav__secondary">
                            <div className="MainNav__secondary-inner">
                                {subMenuItems.map((item) => (
                                    <Button
                                        {...item}
                                        key={item.text}
                                        className={classNames(
                                            'MainNav__secondary_button',
                                            className,
                                        )}
                                        variant="outlined"
                                    />
                                ))}
                            </div>
                        </Collapse>
                    )}
                </div>
            ))}
        </div>
    );
}
